<template>
    <v-app id="login">
        <div class="portal">
            <!-- Panel institucional -->
            <aside class="portal__hero">
                <div class="hero__fondo" aria-hidden="true">
                    <span class="orbe orbe--1"></span>
                    <span class="orbe orbe--2"></span>
                    <span class="orbe orbe--3"></span>
                    <span class="trama"></span>
                </div>

                <div class="hero__contenido">
                    <div class="hero__marca">
                        <div class="hero__placa">
                            <img :src="logoInfop" alt="INFOP Virtual">
                        </div>
                        <div class="hero__marca-texto">
                            <span class="hero__eyebrow">Instituto Nacional de Formación Profesional</span>
                            <span class="hero__producto">Plataforma de Certificación</span>
                        </div>
                    </div>

                    <h1 class="hero__titulo">
                        Tus certificados,<br>
                        <em>verificados</em> y siempre a la mano.
                    </h1>

                    <ul class="hero__lista">
                        <li>
                            <span class="hero__icono"><v-icon>workspace_premium</v-icon></span>
                            <div>
                                <strong>Descarga inmediata</strong>
                                <span>Obtén tu certificado en PDF en cuanto apruebas el curso.</span>
                            </div>
                        </li>
                        <li>
                            <span class="hero__icono"><v-icon>qr_code_2</v-icon></span>
                            <div>
                                <strong>Autenticidad con código QR</strong>
                                <span>Cada documento se valida en línea contra el registro oficial.</span>
                            </div>
                        </li>
                        <li>
                            <span class="hero__icono"><v-icon>history_edu</v-icon></span>
                            <div>
                                <strong>Historial completo</strong>
                                <span>Consulta todos tus cursos aprobados en un solo lugar.</span>
                            </div>
                        </li>
                    </ul>

                    <div class="hero__ayuda" v-if="$slots.ayuda">
                        <slot name="ayuda"></slot>
                    </div>

                    <div class="hero__pie">
                        <span class="hero__linea"></span>
                        <span>Gobierno de la República de Honduras</span>
                    </div>
                </div>
            </aside>

            <!-- Panel de acceso -->
            <main class="portal__acceso">
                <div class="acceso__tarjeta">
                    <img class="acceso__gobierno" :src="logoGobierno"
                         alt="Gobierno de la República de Honduras · Instituto Nacional de Formación Profesional">

                    <header class="acceso__cabecera">
                        <span class="acceso__eyebrow">{{ eyebrow }}</span>
                        <h2 class="acceso__titulo">{{ titulo }}</h2>
                        <p class="acceso__subtitulo">{{ subtitulo }}</p>
                    </header>

                    <slot></slot>

                    <footer class="acceso__pie" v-if="$slots.pie">
                        <slot name="pie"></slot>
                    </footer>
                </div>

                <slider-popup contexto="login"/>

                <p class="acceso__legal">
                    Sistema oficial de certificación del INFOP. La autenticidad de cada documento
                    puede verificarse con el código QR impreso en el certificado.
                </p>
            </main>
        </div>
    </v-app>
</template>

<script>
/**
 * Marco visual compartido por las pantallas de acceso (certificados,
 * y administración). El formulario va en el slot por defecto;
 * los enlaces secundarios en el slot "pie".
 */
import SliderPopup from "@/components/Videos/SliderPopup.vue";
import {apariencia, logosPredeterminados} from "@/services/apariencia";

export default {
    name: 'LoginLayout',
    components: {SliderPopup},
    props: {
        eyebrow: {type: String, default: 'Acceso'},
        titulo: {type: String, required: true},
        subtitulo: {type: String, default: ''},
    },
    data() {
        return {
            // Estado reactivo de Administración → Apariencia (logos del tema vigente).
            apariencia,
        };
    },
    computed: {
        /** Logos del tema vigente, con respaldo a los assets empaquetados si el API no respondió. */
        logoGobierno() {
            return this.apariencia.logos.gobierno || logosPredeterminados.gobierno;
        },
        logoInfop() {
            return this.apariencia.logos.infop || logosPredeterminados.infop;
        },
    },
}
</script>

<style src="@/pages/Login/Login.scss" lang="scss"/>
